import { Service } from '@/tools'
export class contractInfoService<T extends TContract.Info> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TContract.Info}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  // 合同分页列表
  pageContractInfo = <K extends T['ApiPageContractInfo']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiPageContractInfo', data)
  // 合同选择器
  pageContractInfoSelector = <K extends T['ApiPageContractInfoSelector']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiPageContractInfoSelector', data)
  // 合同删除
  deleteContractById = <K extends T['ApiDeleteContractById']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiDeleteContractById', data)
  // 合同激活
  activateContract = <K extends T['ApiActivateContract']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiActivateContract', data)
  // 合同终止
  terminateContract = <K extends T['ApiActivateContract']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiTerminateContract', data)
  // 合同提交
  submitContract = <K extends T['ApiSubmitContract']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiSubmitContract', data)
  // 合同导出
  exportContract = <K extends T['ApiExportContract']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiExportContract', data)
  // 合同历史记录
  getHistoryVersionList = <K extends T['ApiGetHistoryVersionList']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiGetHistoryVersionList', data)

  // 采购合同详情
  queryPurchaseContractById = <K extends T['ApiQueryPurchaseContractById']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiQueryPurchaseContractById', data)

  // 销售合同详情
  querySalesContractById = <K extends T['ApiQuerySalesContractById']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiQuerySalesContractById', data)
  // 新增采购合同
  addPurchaseContract = <K extends T['ApiAddPurchaseContract']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAddPurchaseContract', data)
  // 新增销售合同
  addSalesContract = <K extends T['ApiAddSalesContract']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAddSalesContract', data)
  // 编辑合同
  updateContract = <K extends T['ApiUpdateContract']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdateContract', data)
  // 变更合同
  changeContract = <K extends T['ApiChangeContract']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiChangeContract', data)
  // 合同折扣商品分页列表
  pageCommodityList = <K extends T['ApiPageCommodityList']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiPageCommodityList', data)

  // 联营合同----------
  // 联营合同详情-/api/contract/info/v1/queryUnitizationContractById
  queryUnitizationContractById = <K extends T['ApiQueryUnitizationContractById']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiQueryUnitizationContractById', data)
  // 新增联营合同-/api/contract/info/v1/addUnitizationContract
  addUnitizationContract = <K extends T['ApiAddUnitizationContract']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiAddUnitizationContract', data)

  // 合作出版合同----------
  // 新增合作出版合同-/api/contract/info/v1/addPublishContract
  addPublishContract = <K extends T['ApiAddPublishContract']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAddPublishContract', data)
  // 合作出版合同详情-/api/contract/info/v1/queryPublishContractById
  queryPublishContractById = <K extends T['ApiQueryPublishContractById']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiQueryPublishContractById', data)

  // 服务合同----------
  // 新增服务合同-/api/contract/info/v1/addServeContract
  addServeContract = <K extends T['ApiAddServeContract']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAddServeContract', data)
  // 服务合同详情-/api/contract/info/v1/queryServeContractById
  queryServeContractById = <K extends T['ApiQueryServeContractById']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiQueryServeContractById', data)

  // 其他合同----------
  // 新增其他合同-/api/contract/info/v1/addOtherContract
  addOtherContract = <K extends T['ApiAddOtherContract']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAddOtherContract', data)
  // 其他合同详情-/api/contract/info/v1/queryOtherContractById
  queryOtherContractById = <K extends T['ApiQueryOtherContractById']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiQueryOtherContractById', data)

  // 补充协议----------
  // 补充协议分页列表-/api/contract/info/v1/pageSuppAgreementList
  pageSuppAgreementList = <K extends T['ApiPageSuppAgreementList']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiPageSuppAgreementList', data)
  // 新增补充协议-/api/contract/info/v1/addSuppAgreement
  addSuppAgreement = <K extends T['ApiAddSuppAgreement']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAddSuppAgreement', data)
  // 补充协议详情-/api/contract/info/v1/queryPublishContractById
  querySuppAgreementById = <K extends T['ApiQuerySuppAgreementById']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiQuerySuppAgreementById', data)
  //提供给销售中心-根据合同ID获取账期
  queryAccountPeriodByContractId = <K extends T['ApiQueryAccountPeriodByContractId']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiQueryAccountPeriodByContractId', data)
}
